import examplePlugin from './blaze-plugins/example';
import scContentPlugin from './blaze-plugins/sc-content';
import listQueryVariablesPlugin from './blaze-plugins/list-query-variables-plugin';

export default function buildConfig(config) {
  // To set custom plugins into the project.
  config.plugins.set(examplePlugin, {});
  config.plugins.set(scContentPlugin, {});
  config.plugins.set(listQueryVariablesPlugin, {});

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };

  return config;
}
